import mobx, { observable, action } from 'mobx';
import agent from '../services/web/agent';

class SystemLocalesStore {

    @observable loadingLanguages;
    @observable languages;

    @action getSystemLocales() {
        this.loadingLanguages = true;

        return agent.SystemLocales.getSystemLocales()
            .then(action((languages) => {
                this.languages = languages;
            }))
            .finally(action(() => { 
                
                this.loadingLanguages = false;
            }));
    }
}

export default new SystemLocalesStore();